export default "__VITE_ASSET__BcUQXaLe__"